import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as viCtsServices from "../../../services/viCts/viCtsService";

export const fetchViCtsListViewData = createAsyncThunk(
  "vi-cts/fetchListView",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await viCtsServices.fetchViCtsListViewData(payload);
      if (!result?.success) {
        return rejectWithValue(result?.message || "Something went wrong.");
      }

      return result?.data || {};
    } catch (err) {
      console.error("fetchViCtsListViewData error:", err);
      return rejectWithValue(
        err?.response?.data?.message || "Internal Server Issue.",
      );
    }
  },
);

export const fetchViCtsTransferSettingHistoricalData = createAsyncThunk(
  "vi-cts/fetchTransferSettingHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await viCtsServices.fetchViCtsTransferSettingHistory(payload);
      if (!result?.success) {
        return rejectWithValue(result?.message || "Something went wrong.");
      }

      return result?.data || {};
    } catch (err) {
      console.error("fetchViCtsTransferSettingListData error:", err);
      return rejectWithValue(
        err?.response?.data?.message || "Internal Server Issue.",
      );
    }
  },
);


export const setTransferRateDispatcher = createAsyncThunk(
  'vi-cts/setTransferRate',
  async (payload, thunkAPI) => {
    try {
      const apiResponse = await viCtsServices.setTransferRate(payload);
      if (!apiResponse?.success || !apiResponse?.data) {
        return thunkAPI.rejectWithValue(apiResponse?.message || "Something went wrong.");
      } else {
        return apiResponse?.message || "Setting Successfully Updated";
      }
    } catch (err) {
      console.log("Error inside setTransferRateDispatcher : ", err);
      const msg = typeof err === 'string' ? err : (err?.message || err?.response?.data?.message);
      thunkAPI.rejectWithValue(msg || "Internal Server Issue.");
    }
  }
)


export const getPromotionalContactsDispatcher = createAsyncThunk(
  'vi-cts/getPromotionalContacts',
  async (payload, thunkAPI) => {
    try {
      const apiResponse = await viCtsServices.getPromotionalContactBatch(payload);
      if (!apiResponse?.success || !apiResponse?.data) {
        return thunkAPI.rejectWithValue(apiResponse?.message || "Something went wrong.");
      } else {
        return apiResponse?.message;
      }
    } catch (err) {
      console.log("Error inside getPromotionalContactsDispatcher : ", err?.response?.data?.message);
      const msg = typeof err === 'string' ? err : (err?.message || err?.response?.data?.message);
      thunkAPI.rejectWithValue(msg || "Internal Server Issue.");
    }
  }
)

export const initiateFileDownloadThunk = createAsyncThunk(
  'vi-cts/initiateFileDownloadThunk',
  async (payload, thunkAPI) => {
    try {
      const apiResponse = await viCtsServices.initiateFileDownload(payload);
      if (!apiResponse?.success || !apiResponse?.data) {
        return thunkAPI.rejectWithValue(apiResponse?.message || "Something went wrong.");
      } else {
        return apiResponse?.message;
      }
    } catch (err) {
      console.log("Error inside initiateFileDownloadThunk : ", err?.response?.data?.message);
      const msg = typeof err === 'string' ? err : (err?.message || err?.response?.data?.message);
      thunkAPI.rejectWithValue(msg || "Internal Server Issue.");
    }
  }
)


const initialState = {
  listView: {
    list: [],
    loading: false,
    error: null,
    pagination: {},
  },

  transferSettingList: {
    list: [],
    loading: false,
    error: null,
    pagination: {},
  },
};

const viCtsSlice = createSlice({
  name: "VI_CTS",
  initialState,
  reducers: {
    resetListView: (state) => {
      state.listView = initialState.listView;
    },
    resetTransferSettingList: (state) => {
      state.transferSettingList = initialState.transferSettingList;
    },
  },

  extraReducers: (builder) => {
    //  VI-CTS LIST VIEW
    builder
      .addCase(fetchViCtsListViewData.pending, (state) => {
        state.listView.loading = true;
        state.listView.error = null;
      })
      .addCase(fetchViCtsListViewData.fulfilled, (state, action) => {
        state.listView.loading = false;
        state.listView.list = action.payload?.list || [];
        state.listView.pagination = action.payload?.pagination || {};
      })
      .addCase(fetchViCtsListViewData.rejected, (state, action) => {
        state.listView.loading = false;
        state.listView.error =
          action.payload || "Failed to load list view data";
      });

    // TRANSFER SETTING LIST
    builder
      .addCase(fetchViCtsTransferSettingHistoricalData.pending, (state) => {
        state.transferSettingList.loading = true;
        state.transferSettingList.error = null;
      })
      .addCase(fetchViCtsTransferSettingHistoricalData.fulfilled, (state, action) => {
        state.transferSettingList.loading = false;
        state.transferSettingList.list = action.payload?.list || [];
        state.transferSettingList.pagination = action.payload?.pagination || {};
      })
      .addCase(fetchViCtsTransferSettingHistoricalData.rejected, (state, action) => {
        state.transferSettingList.loading = false;
        state.transferSettingList.error =
          action.payload || "Failed to load transfer setting data";
      });
  },
});

export const { resetListView, resetTransferSettingList } = viCtsSlice.actions;

export const viCtsReducer = viCtsSlice.reducer;
